import dateFormat from 'dateformat';
import { v4 as uuidv4 } from 'uuid';
import { extractCountryCode, getLastDayOFMounth } from './helpers';
import { JOB_STATUS } from './constants';

export const dateValidator = (date) => (Number.isNaN(Date.parse(date)) ? null : dateFormat(date, 'isoDate'));

export const parseWorks = (works) =>
  Array.isArray(works)
    ? works.map((work) => ({
        CompanyName: work?.EmployerName || null,
        Title: work?.Title || null,
        Description: work?.Description || null,
        CurrentlyWorkThere: work?.CurrentlyWorkThere || false,
        StartDate: dateValidator(work?.StartDate),
        EndDate: dateValidator(work?.EndDate)
      }))
    : [];

export const parseTrainings = (certificates) =>
  Array.isArray(certificates)
    ? certificates.map((certificate) => ({
        CertificationType: certificate?.CertificationType || null,
        CertificationId: certificate?.CertificationId || null,
        ValidUntil: dateValidator(certificate?.ValidUntil) ? dateFormat(certificate?.ValidUntil, 'isoDate') : null,
        StartDate: dateValidator(certificate?.StartDate),
        EndDate: dateValidator(certificate?.EndDate)
      }))
    : [];

export const parseEducations = (educations) =>
  Array.isArray(educations)
    ? educations.map((education) => ({
        UniversityName: education?.SchoolName || null,
        Degree: education?.Degree?.Name || null,
        DegreeType: 'null', // need changes after design changes will be made
        FieldOfStudy: education?.Major || null,
        City: 'null', // need changes after design changes will be made
        State: 'null', // need changes after design changes will be made
        Country: 'null', // need changes after design changes will be made
        StartDate: dateValidator(education?.StartDate) ? dateFormat(education?.StartDate, 'isoDate') : null,
        EndDate: dateValidator(education?.EndDate) ? dateFormat(education?.EndDate, 'isoDate') : null,
        CurrentlyStudyHere: education.CurrentlyStudyHere || false
      }))
    : [];

export const parseSkills = (skills) =>
  Array.isArray(skills)
    ? skills
        .map((skill) => ({
          SkillName: skill?.Name || null,
          TopSkill: skill?.TopSkill || false
        }))
        .filter(({ SkillName }) => SkillName)
    : [];

export const getDataByProperty = (data, propForGetting) => {
  const filteredData = [];

  if (Array.isArray(data))
    data.forEach((item) => {
      if (item[propForGetting])
        filteredData.push({
          [propForGetting]: item[propForGetting]
        });
    });

  return filteredData;
};

export const cvParser = (sourceCV) => ({
  City: sourceCV.PersonalDetails.City,
  State: sourceCV.PersonalDetails.State,
  Country: sourceCV.PersonalDetails.Country,
  Phone: sourceCV.PersonalDetails.Phone.replace(/[^0-9]/g, ''),
  PhoneCountryCode: extractCountryCode(sourceCV.PersonalDetails.Phone),
  PhoneType: 'Mobile',
  ContractWork: sourceCV.JobsFilters.contract.contrActive,
  PermanentWork: sourceCV.JobsFilters.permanent.permActive,
  OpenToRelocation: sourceCV.JobsFilters.relocationWork,
  OpentoRemoteWork: sourceCV.JobsFilters.remoteWork,
  WorkHistories: parseWorks(sourceCV.JobExperienceDetails),
  Educations: parseEducations(sourceCV.EducationDetails),
  TrainingCertificates: parseTrainings(sourceCV.TrainingDetails),
  UserIndustries: getDataByProperty(sourceCV.JobPreferences.industry, 'IndustryId'),
  UserJobFunctions: getDataByProperty(sourceCV.JobPreferences.jobs, 'JobFunctionId'),
  Summary: sourceCV.Summary,
  UserRates: [
    {
      Hourly: Number(sourceCV.JobsFilters.contract.hourly),
      Daily: Number(sourceCV.JobsFilters.contract.daily),
      Annual: Number(sourceCV.JobsFilters.permanent.salary),
      Currency: sourceCV.JobsFilters.contract.currency
    }
  ],
  UserSkills: parseSkills(sourceCV.Skills)
});

export const cvPreParsing = (obj, propertyName, endDateLastDay = false) =>
  obj[propertyName]?.map((item) => {
    const start = item?.StartDate ? new Date(item?.StartDate) : '-';
    if (item?.StartDate) start.setHours(start.getHours() + 11);

    const end = item?.EndDate ? new Date(item?.EndDate) : '-';
    if (item?.EndDate) end.setHours(end.getHours() + 11);

    const current = new Date();
    current.setHours(current.getHours() + 11);

    let endValue = current;
    if (item?.EndDate !== 'Present' && item?.EndDate !== '') {
      endValue = endDateLastDay ? getLastDayOFMounth(item.EndDate) : end;
    }

    return {
      ...item,
      StartDate: dateFormat(start, 'isoDateTime'),
      EndDate: dateFormat(endValue, 'isoDateTime')
    };
  }) || [];

export const addIdsToDataObject = (obj) => {
  const objWithIds = { ...obj };
  const keys = Object.keys(objWithIds);

  keys.forEach((key) => {
    if (Array.isArray(objWithIds[key])) {
      objWithIds[key] = objWithIds[key].map((value) => ({ ...value, id: uuidv4(3) }));
    }
  });

  return objWithIds;
};

export const parseJobs = (jobs) => {
  if (jobs?.[0]?.JobTitle) return jobs;
  if (jobs?.[0]?.JobApplicationStatus)
    return jobs.map((job) => ({
      ...job.Job,
      IsApplied: job.Status === JOB_STATUS.APPLIED,
      IsOpen: job.Status !== JOB_STATUS.CLOSED,
      UIName: job.JobApplicationStatus.UIName
    }));
  return jobs.map((job) => job.Job);
};
